// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.panel .v-skeleton-loader__image {\n  height: 65px;\n  border-radius: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
